import { CircleAlert } from "lucide-react"

import {
  TableIconMessagePlaceholder,
  TableIconMessagePlaceholderProps,
} from "./TableIconMessagePlaceholder"
import { classNames } from "../../../../lib/classNames"

export type TableEmptyPlaceholderProps = Omit<
  TableIconMessagePlaceholderProps,
  "icon"
>

export function TableEmptyPlaceholder({
  className,
  message,
  ...otherProps
}: TableEmptyPlaceholderProps) {
  return (
    <TableIconMessagePlaceholder
      icon={CircleAlert}
      iconClassName="text-v2-foreground-default-weaker"
      message={message}
      className={classNames("color-subtle text-wrap", className)}
      {...otherProps}
    />
  )
}
